import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useSelector } from 'react-redux';
import { styled, keyframes, css } from 'styled-components';
import THEME from '../theme.js';
import X from './Icons/X.js';
const Modal = (props) => {
    const leftNavOpen = useSelector((s) => s.leftNavOpen);
    useEffect(() => {
        document.addEventListener('keydown', onEscapePress);
        return () => {
            document.removeEventListener('keydown', onEscapePress);
        };
    }, []);
    // A dropdown inside the modal marks the Escape it consumed as handled
    const onEscapePress = (evt) => {
        if (evt.code === 'Escape' && !evt.defaultPrevented) {
            props.onToggle();
        }
    };
    const referenceNode = props.reference && props.reference.current;
    const referenceDomNodeBoundingRect = referenceNode && referenceNode.getBoundingClientRect();
    return createPortal(React.createElement(Wrapper, { reference: referenceDomNodeBoundingRect, className: "modal open", onClick: props.onToggle, leftNavOpen: leftNavOpen },
        React.createElement(ModalStyled, { maxWidth: props.maxWidth, onClick: (e) => e.stopPropagation(), reference: referenceDomNodeBoundingRect, padding: props.padding, headerMargin: props.headerMargin, fullscreen: props.fullscreen },
            React.createElement("h2", null,
                props.header,
                React.createElement(X, { onClick: props.onToggle, style: { cursor: 'pointer' }, className: "close-modal-x" })),
            React.createElement("div", { className: "modal-body" }, props.children),
            props.footer && React.createElement("div", { className: "modal-footer" }, props.footer))), document.body);
};
export default Modal;
const fadeIn = keyframes `
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
const slideIn = keyframes `
  from {
    transform: translateY(5px);
  }
  to {
    transform: translateY(0px);
  }
`;
const slideInAnimation = css `
  animation: ${slideIn} 100ms;
`;
const Wrapper = styled.div `
  background-color: ${(props) => props.reference ? 'rgba(0, 0, 0, 0.1)' : 'rgba(0, 0, 0, 0.3)'};
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  animation: ${fadeIn} 0.1s ease-in;
  z-index: 100;
`;
const ModalStyled = styled.div `
  background-color: ${THEME.COLOR_SECONDARY};
  width: 100%;
  padding: ${(props) => props.padding ? props.padding : `${THEME.GRID_SPACING}px`};
  border-radius: ${(props) => (props.fullscreen ? '0' : '5px')};
  max-width: ${(props) => props.fullscreen ? '100%' : props.maxWidth ? props.maxWidth : '900px'};
  margin: ${(props) => (props.fullscreen ? '0' : '70px auto 50px auto')};

  ${(props) => props.fullscreen
    ? `
      height: 100vh;

      .modal-body {
        overflow-y: scroll;
        height: calc(100vh - 63px);
      }
      `
    : ''};

  .modal-footer {
    border-top: 1px solid ${THEME.COLOR_GREY};
    padding: 15px 20px;
    margin: ${THEME.GRID_SPACING}px -${THEME.GRID_SPACING}px -${THEME.GRID_SPACING}px -${THEME.GRID_SPACING}px;
  }

  ${(props) => props.reference
    ? `
          position: fixed;
          top: ${props.reference.y + props.reference.height + 15}px;
          margin-top: 0;
          right: calc(100vw - ${props.reference.right + 10}px);

          .modal-body {
            max-height: calc(100vh - ${props.reference.y + props.reference.height + 120}px);
            overflow-y: scroll;
            -webkit-overflow-scrolling: touch;
          }

          &::before {
            content: '';
            z-index: 1;
            height: 0;
            width: 0;
            position: absolute;
            right: ${props.reference.width / 2}px;
            top: -20px;
            border: 10px solid ${THEME.COLOR_SECONDARY};
            border-right-color: transparent;
            border-top-color: transparent;
            border-left-color: transparent;
            opacity: 1;
          }
        `
    : slideInAnimation};
  h2 {
    margin: ${(props) => props.headerMargin ? props.headerMargin : '0px 0px 20px 0px'};
    svg {
      float: right;
    }
  }

  object,
  iframe {
    width: 100%;
    height: calc(100vh - 215px);
  }

  img {
    max-width: 100%;
  }
`;
//# sourceMappingURL=Modal.js.map